import AppRoute from "models/AppRoute"

const ReservationCreateRoute = new AppRoute({
    route: "/reservation/create",
    navbar: true,
    authRequired: true,
})

export default ReservationCreateRoute
